import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH } from "../../../utils/Constants";
import {
  handleServerValidations,
  DT,
  globalLoader
} from "../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../utils/customError";
import { useTranslation } from "react-i18next";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import { Details ,EditSubscription } from "../../admin/services/subscriptionPlan.services";


const SubscriptionEdit = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [previewimage, setPreviewImage] = useState("");

  const [taglines, setTaglines] = useState([""]);

  const [saveType, setSaveType] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("Subscription Plans"),
      url: "/admin/subscription/subscription-plan/list/1",
    },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    Details(params._id)
      .then((response) => {
        const data = response && response.data ? response.data : {};
        setShowDefault(data);
        setPreviewImage(data.profile_image);
        if (data.taglines && Array.isArray(data.taglines) && data.taglines.length > 0) {
          setTaglines(data.taglines);
        } else {
          setTaglines([""]);
        }
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  const handleTaglineChange = (index, value) => {
    const updated = [...taglines];
    updated[index] = value;
    setTaglines(updated);
  };

  const handleAddTagline = () => {
    setTaglines([...taglines, ""]);
  };

  const handleRemoveTagline = (index) => {
    const updated = taglines.filter((_, idx) => idx !== index);
    setTaglines(updated.length > 0 ? updated : [""]);
  };

  const validationSchema = Yup.object().shape({
   
    name: Yup.string()
  .required("Name is required")
  .max(30, "Name cannot be more than 30 characters")
  .test('no-spaces', 'Name is required', (value) => value && value.trim() !== ''),

description: Yup.string()
  .required("Description is required")
  .max(200, "Description cannot be more than 200 characters")
  .test('no-spaces', 'Description is required', (value) => value && value.trim() !== ''),


  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
    
      name: showdefault && showdefault.name ? showdefault.name : "",
      description : showdefault && showdefault.description ? showdefault.description : ""
    
      
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      const filteredTaglines = taglines
        .map((t) => (typeof t === "string" ? t.trim() : ""))
        .filter((t) => t.length > 0);

      const payload = {
        _id: params._id,
        name: values.name,
        description: values.description,
        taglines: filteredTaglines,
      };

      EditSubscription(payload)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/subscription/subscription-plan/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          globalLoader(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          console.log("error ====> ", error);
        });
    },
  });
  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">
                    {t("Edit Subscription Plan")}
                  </h6>
                </div>
                <div className="row row-sm">

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("label_name")}:
                      <span className="requirestar">*</span>{" "}
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder={t("label_enter_name")}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError shortCodes={[INPUT_MAX_25]} name="name" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-12 text-center form-group">
                    <label htmlFor="description" className="text-left d-flex">
                      {t("label_description")}:<span className="requirestar">*</span>{" "}
                    </label>
                    <textarea
                            name="description"
                            id="description"
                            rows="5"
                            type="text"
                    
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.description}
                            className="form-control w-100"
                          />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="description" form={formik} />
                    </span>
                  </div>

                  <div className="col-lg-12 form-group">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="text-left d-flex mb-0">
                        {t("Taglines")}:
                      </label>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleAddTagline}
                        title={t("Add Tagline")}
                      >
                        <i className="fa fa-plus mr-1"></i> {t("Add Tagline")}
                      </button>
                    </div>

                    {taglines.map((item, index) => (
                      <div key={index} className="input-group mb-2">
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-light text-muted">
                            <i className="fa fa-check text-warning mr-1"></i>
                            <small>#{index + 1}</small>
                          </span>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={t("Enter tagline (e.g. Exclusive travel discounts)")}
                          value={item}
                          maxLength={150}
                          onChange={(e) => handleTaglineChange(index, e.target.value)}
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-outline-success"
                            onClick={handleAddTagline}
                            title={t("Add Tagline")}
                          >
                            <i className="fa fa-plus"></i>
                          </button>
                          {taglines.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={() => handleRemoveTagline(index)}
                              title={t("Remove Tagline")}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-5">
                    <button
                      onClick={() => {
                        setSaveType("Save");
                      }}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => {
                        setSaveType("");
                      }}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default SubscriptionEdit;